import React from "react";
import { useRouter } from "next/router";
import { Navigation as PolarisNavigation, Select, Stack, Tag } from "@shopify/polaris";
import { CollectionsMajor, RecentSearchesMajor } from "@shopify/polaris-icons";
import { Suggestions, useConfig, useSearch } from "@usereactify/search";
import { useAppContext } from "~/providers/app";
import { Filters } from "../components/filters";

export function Navigation() {
  const router = useRouter();
  const { shop, market, setMarket } = useAppContext();

  const configHook = useConfig(shop);
  const searchHook = useSearch();

  const marketOptions = React.useMemo<Array<{ label: string; value: string }>>(() => {
    return [
      {
        label: "None",
        value: "",
      },
      ...(configHook.config?.markets.map((item) => ({
        label: item.label,
        value: item.id,
      })) ?? []),
    ];
  }, [configHook.config?.markets]);

  return (
    <PolarisNavigation location={router.pathname ?? "/"}>
      <div
        style={{
          paddingLeft: "1rem",
          paddingRight: "1rem",
          paddingBottom: "1rem",
        }}
      >
        <Select
          label="Market"
          labelInline
          value={market}
          options={marketOptions}
          onChange={(value) => setMarket(value)}
        />
      </div>
      <PolarisNavigation.Section
        items={[
          {
            url: router.pathname === "/search" ? "/search" : undefined,
            label: "Search",
            icon: RecentSearchesMajor,
            onClick: () => router.push("/search"),
          },
          {
            url: router.pathname.includes("/collections") ? router.pathname : undefined,
            label: "Collection",
            icon: CollectionsMajor,
            onClick: () => router.push("/collections"),
          },
        ]}
      />
      <PolarisNavigation.Section separator items={[]} />
      <Suggestions
        field="title"
        render={(renderProps) =>
          renderProps.suggestions.length > 0 ? (
            <div className="Polaris-ChoiceList">
              <legend className="Polaris-ChoiceList__Title">{"Suggestions"}</legend>
              <Stack spacing="tight">
                {renderProps.suggestions.map((suggestion) => (
                  <Tag key={suggestion.text} onClick={() => searchHook.submitSearchTerm(suggestion.text)}>
                    {suggestion.text}
                  </Tag>
                ))}
              </Stack>
            </div>
          ) : null
        }
      />
      {(router.pathname.includes("/collections/") || router.pathname.includes("/search")) && <Filters />}
    </PolarisNavigation>
  );
}

export function NavigationMobile() {
  const router = useRouter();
  return (
    <div className="Polaris-Navigation-Mobile">
      <PolarisNavigation location={router.pathname ?? "/"}>
        <PolarisNavigation.Section
          items={[
            {
              url: router.pathname === "/search" ? "/search" : undefined,
              label: "Search",
              icon: RecentSearchesMajor,
              onClick: () => router.push("/search"),
            },
            {
              url: router.pathname === "/collections" ? "/collections" : undefined,
              label: "Collection",
              icon: CollectionsMajor,
              onClick: () => router.push("/collections"),
            },
          ]}
        />
      </PolarisNavigation>
    </div>
  );
}
